@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.popover {
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  width: 235px;
  background-color: var(--glass-sidebar-background-color, var(--sidebar-background-color));
}

.triggerContainer {
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  overflow: hidden;

  .logoContainer {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding-left: 8px;

    img {
      height: 36px;
      min-height: 36px;
      object-fit: contain;
    }

    svg {
      height: 36px;
      width: 101px;
    }
  }

  .workspaceNameContainer {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;

    .workspaceLogoButton {
      height: 24px;
      width: 24px;
      border-radius: 6px;
    }

    .workspaceName {
      @include xs-sohne-medium;

      [data-autopilot-system-redesign='on'] & {
        @include line-clamp;
        @include sm-sohne;
      }
    }
  }

  .chevronDownContainer {
    display: flex;
    align-items: center;
  }
}
